/* eslint-disable no-unused-vars */
import apiClient from "@/config/api";
const RESOURCE = "/properties";
const PROP = "/property";

const actions = {
  getImovel({ commit }, page) {
    const config = {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    };
    // console.log(config)
    return new Promise((resolve, reject) => {
      apiClient
        .get(`${RESOURCE}?page=${page}`, config)
        .then((res) => {
          commit("SET_IMOVEIS", res.data.data);
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          console.error("API Error:", err);
        });
    });
  },
  getAllImovel({ commit }, pagination = 1) {
    const page = typeof pagination === "number" ? pagination : pagination.page || 1;
    const perPage = typeof pagination === "number" ? 10 : pagination.perPage || 10;
    const publishedOnly = typeof pagination === "object" && pagination.publishedOnly
      ? "&published_only=1"
      : "";
    const config = {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    };
    // console.log(config);
    return new Promise((resolve, reject) => {
      apiClient
        .get(`${RESOURCE}/all?page=${page}&per_page=${perPage}${publishedOnly}`, config)
        .then((res) => {
          commit("SET_IMOVEIS", res.data.data);
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          console.error("API Error:", err);
        });
    });
  },
  getImovelOptions({ commit }) {
    const config = {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    };

    return new Promise((resolve, reject) => {
      apiClient
        .get(`${RESOURCE}/options`, config)
        .then((res) => {
          commit("SET_IMOVEIS_OPTIONS", res.data.data);
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          console.error("API Error:", err);
        });
    });
  },
  // eslint-disable-next-line no-unused-vars
  getImovelBySlug({ commit }, slug) {
    const config = {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    };

    return new Promise((resolve, reject) => {
      apiClient
        .get(`${RESOURCE}/slug/${slug}`, config)
        .then((res) => {
          // commit();
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          console.error("API Error:", err);
        });
    });
  },
  storeImovel({ commit }, imovelData) {
    const config = {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    };

    return new Promise((resolve, reject) => {
      apiClient
        .post(RESOURCE, imovelData, config)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
          console.error("API Error:", err);
        });
    });
  },
  updateImovel({ commit }, { slug, formData }) {
    const config = {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    };

    formData.set("_method", "PUT");

    return apiClient
      .post(`properties/slug/${slug}`, formData, config)
      .then((res) => res.data);
  },
  destroy({ commit }, slug) {
    const config = {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    };
    return new Promise((resolve, reject) => {
      apiClient
        .delete(`${RESOURCE}/slug/${slug}`, config)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  toggleFeatured({ commit }, slug) {
    const config = {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    };
    return new Promise((resolve, reject) => {
      apiClient
        .patch(`${RESOURCE}/slug/${slug}/featured`, {}, config)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
          console.error("API Error:", err);
        });
    });
  },
  // ...ações já existentes (getImovelOptions, etc.)

  storeDraft({ commit }, payload) {
    const config = {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    };

    return new Promise((resolve, reject) => {
      apiClient
        .post(`${PROP}/draft`, payload, config)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
          console.error("API Error:", err);
        });
    });
  },

  // Passo 1 (edição): utilizador voltou atrás e alterou a informação básica
  updateBasicInfo({ commit }, { id, payload }) {
    const config = {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    };

    return new Promise((resolve, reject) => {
      apiClient
        .put(`${PROP}/${id}/basic`, payload, config)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
          console.error("API Error:", err);
        });
    });
  },

  // Passo 2: grava preço e características no mesmo rascunho
  updateDetails({ commit }, { id, payload }) {
    const config = {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    };

    return new Promise((resolve, reject) => {
      apiClient
        .put(`${PROP}/${id}/details`, payload, config)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
          console.error("API Error:", err);
        });
    });
  },

  // Passo 3: envia as imagens e finaliza — muda o status para "published"
  publishImovel({ commit }, { id, formData }) {
    const config = {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        "Content-Type": "multipart/form-data",
      },
    };

    return new Promise((resolve, reject) => {
      apiClient
        .post(`${PROP}/${id}/publish`, formData, config)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
          console.error("API Error:", err);
        });
    });
  },

  // Cancelar/desistir: apaga definitivamente o rascunho (e as suas imagens)
  discardImovel({ commit }, id) {
    const config = {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    };

    return new Promise((resolve, reject) => {
      apiClient
        .delete(`${PROP}/${id}/discard`, config)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
          console.error("API Error:", err);
        });
    });
  },
};

export default actions;
